<template>
  <div class="static-page">
    <main class="mx-auto max-w-screen-xl px-4 py-12">
      <div class="flex flex-col items-center justify-center max-w-4xl mx-auto mt-24">
        <h1 class="gradient-title">{{ store.systemConfigs.contact_meta_title }}</h1>
        <div class="text-lg lg:text-xl mt-4 text-center">
          {{ store.systemConfigs.contact_meta_description }}
        </div>
      </div>

      <form class="bg-white dark:bg-stone-800 p-4 shadow-lg mx-auto max-w-4xl mt-20" @submit.prevent="onSubmit">
        <div class="grid grid-cols-3 gap-6">
          <div class="col-span-3 lg:col-span-1">
            <div>
              <label class="input-label">Name (*)</label>
              <input
                v-model="form.name"
                type="text"
                placeholder="Your name"
                autofocus
                class="input-field w-full mt-2"
              />
            </div>
          </div>
          <div class="col-span-3 lg:col-span-1">
            <div>
              <label class="input-label">Email (*)</label>
              <input v-model="form.email" type="email" placeholder="Your email" class="input-field w-full mt-2" />
            </div>
          </div>
          <div class="col-span-3 lg:col-span-1">
            <div>
              <label class="input-label">Subject</label>
              <select v-model="form.subject" class="input-field w-full mt-2">
                <option value="">--- Choose a subject ---</option>
                <option v-for="subject in subjects" :key="subject[0]" :value="subject[0]">
                  {{ subject[1] }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-span-3">
            <div>
              <label class="input-label">Message (*)</label>
              <textarea
                v-model="form.content"
                rows="5"
                placeholder="Your message (5..2000 characters)"
                class="input-field w-full mt-2"
              />
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-2 items-center mt-8">
          <Checkbox @success="recaptchaSuccess = true" />
          <button v-if="recaptchaSuccess" type="submit" class="btn btn--lg btn--primary">
            <i class="fa-solid fa-paper-plane"></i>
            <span>Send message</span>
          </button>
        </div>
      </form>
    </main>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import { useHead } from '@unhead/vue'
  import { useRouter } from 'vue-router'
  import { useStore } from '$/stores'
  import { Checkbox } from 'vue-recaptcha'
  import { useNotify } from '$/composables/useNotify'
  import { useRecaptchaProvider } from 'vue-recaptcha'

  useRecaptchaProvider()

  const router = useRouter()
  const store = useStore()
  const { pushNotify, pushError } = useNotify()

  const recaptchaSuccess = ref(false)
  const subjects = ref([
    ['general_inquiry', 'General Inquiry'],
    ['technical_support', 'Technical Support'],
    ['billing_and_payments', 'Billing and Payments'],
    ['feature_request', 'Feature Request'],
    ['bug_report', 'Bug Report'],
    ['partnership', 'Partnership'],
    ['privacy', 'Privacy'],
    ['other', 'Other'],
  ])

  const form = ref({
    subject: '',
  })

  useHead({
    title: store.systemConfigs.contact_meta_title,
    meta: [
      {
        name: 'description',
        content: store.systemConfigs.contact_meta_description,
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: '/contact',
      },
    ],
  })

  const onSubmit = function () {
    store.sending = true
    store
      .createContact(form.value)
      .then(() => {
        router.push({ name: 'FeatureIndex' })
        pushNotify(
          'We’ll get back to you as soon as possible. Thank you for reaching out!',
          'Your message has been sent successfully!'
        )
      })
      .catch((err) => {
        const error = err?.response?.data?.error
        pushError(`Please check your details and try again.\n${error}`, 'Oops! Something went wrong.')
      })
  }
</script>

<style scoped lang="scss">
  .markdown-body {
    background-color: white !important;
    padding: 1rem;
  }
</style>
